import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Button from 'components/buttons/Button'
import dx from 'lib/dashx'
import Stack from 'components/base/Stack'
import Text from 'components/typography/Text'
import useClientMutation from 'hooks/useClientMutation'
import { ADD_ACCOUNT_TOKEN, LOGIN } from 'client/state/auth'

function MfaSetupSuccessPage() {
  const { t } = useTranslation()
  const history = useHistory()
  const { state } = useLocation()

  const emailOrPhone = state?.targetMasked || ''

  const session = state?.session
  const accountId = session?.accountId

  const [addAccountToken] = useClientMutation(ADD_ACCOUNT_TOKEN)
  const [login] = useClientMutation(LOGIN)

  const finishMfaFlow = () => {
    const { accessToken, dashxToken } = session

    addAccountToken({ accountId, dashxToken, token: accessToken })
    dx.setIdentity(accountId, dashxToken)
    login({ accountId })
  }

  useEffect(() => {
    if (!accountId) {
      history.replace('/login')
    }
  }, [accountId, history])

  if (!accountId) return null

  return (
    <Stack direction="column" gutter={20}>
      <Stack direction="column" gutter={13}>
        <Text size="xxxLarge" weight="extralight" color="light">
          {t('mfa.setupSuccess.title')}
        </Text>
        <Text size="small" weight="semibold" color="tertiary">
          {t('mfa.setupSuccess.subtitle', { target: emailOrPhone })}
        </Text>
      </Stack>

      <Button label={t('mfa.setupSuccess.button')} onClick={finishMfaFlow} />
    </Stack>
  )
}

export default MfaSetupSuccessPage
